var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showLanguageSwitch
    ? _c(
        "div",
        { staticClass: "switch-languages" },
        _vm._l(_vm.regionLanguages, function (lang) {
          return _c(
            "div",
            {
              key: lang.id,
              staticClass: "lang-label",
              on: {
                click: function ($event) {
                  return _vm.changeLang(lang)
                },
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.$t(lang.name)) + "\n  ")]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }